import React, { useEffect, useState } from "react"
import { ChevronDownIcon } from "@heroicons/react/24/outline"
import ProductRating from "./ProductRating"
import useT from "../hooks/useT"
import { analyzeRatings, calculateRatingDistribution } from "../utils/ratings"

// Rating + hover popover with the 5..1 star distribution bars.
// variant: default (on a light card) | hero (white, on a dark band)
export default function ProductRatingSummary({ product, onClickReviews, className = "", variant = "default" }) {
  const t = useT()
  const [open, setOpen] = useState(false)
  const [animate, setAnimate] = useState(false)
  const { avgRating, numRatings } = analyzeRatings(product?.ratings)
  const { percentages } = calculateRatingDistribution(product?.ratings)

  useEffect(() => {
    if (!open) return setAnimate(false)
    const id = setTimeout(() => setAnimate(true), 50)
    return () => clearTimeout(id)
  }, [open])

  if (!numRatings) return null

  return (
    <div className={`relative inline-block ${className}`} onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <button type="button" onClick={onClickReviews} className="inline-flex items-center gap-1 cursor-pointer">
        <ProductRating avgRating={avgRating} numRatings={numRatings} variant={variant} />
        <ChevronDownIcon className={`w-4 h-4 ${variant === "hero" ? "text-white" : "text-text_secondary"}`} />
      </button>
      {open && (
        <div className="absolute left-0 top-full z-30 w-[280px] rounded-lg border border-bordered bg-paper p-4 shadow-lg">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-[20px] font-bold">{avgRating.toFixed(1)}</span>
            <span className="text-[13px] text-text_secondary">
              {t("%number% ratings", numRatings) === "%number% ratings" ? `${numRatings} ratings` : t("%number% ratings", numRatings)}
            </span>
          </div>
          <div className="flex flex-col gap-1.5">
            {[5, 4, 3, 2, 1].map((star) => (
              <div key={star} className="flex items-center gap-2 text-[13px]">
                <span className="w-12 shrink-0 text-text_secondary">{star} ★</span>
                <div className="flex-1 h-3 rounded bg-neutral overflow-hidden">
                  <div className="h-full bg-primary_hov transition-all duration-700" style={{ width: animate ? `${percentages[star]}%` : 0 }} />
                </div>
                <span className="w-9 text-right text-text_secondary">{percentages[star]}%</span>
              </div>
            ))}
          </div>
          <div className="pt-3 mt-3 border-t border-bordered text-center">
            <button type="button" onClick={onClickReviews} className="text-[14px] text-primary hover:underline">
              {t`See customer reviews`} ›
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
